import { render } from "./LeasingContent.vue?vue&type=template&id=18bff9ce&scoped=true"
import script from "./LeasingContent.vue?vue&type=script&lang=js"
export * from "./LeasingContent.vue?vue&type=script&lang=js"

import "./LeasingContent.vue?vue&type=style&index=0&id=18bff9ce&lang=scss&scoped=true"
import "./LeasingContent.vue?vue&type=style&index=1&id=18bff9ce&lang=css"

import exportComponent from "/Users/rantalmor/Desktop/volta-vue/proposal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18bff9ce"]])

export default __exports__